import { urlContact, urlPqrs, urlPQR } from "api"
import { post, get } from "api/requests"
import handleErrorMessage from "utils/handleErrorMessage"
import { loading, message } from "../commons/actions"

export const sendMessageContact = async (dispatch, values) => {
  loading(dispatch, true)
  await post(urlContact, { ...values })
    .then(() => {
      loading(dispatch, false)
      message(dispatch, "messageSentSuccesfully")
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch)
      loading(dispatch, false)
      message(dispatch, mssg)
    })
}

export const sendPQRS = async (dispatch, values) => {
  let status = false
  loading(dispatch, true)
  await post(urlPqrs, { ...values })
    .then(() => {
      loading(dispatch, false)
      message(dispatch, "pqrs.messageSent")
      status = true
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch)
      loading(dispatch, false)
      message(dispatch, mssg)
      status = false
    })

  return { status }
}

export const checkGuideNumber = async (dispatch, id) => {
  let status = false
  await get(`${urlPQR}/${id}/guide_number_check`, {})
    .then(() => {
      message(dispatch, "app.guide.validGuide")
      status = true
    })
    .catch(() => {})

  return { status }
}
